<template>
    <div class="notebox">
        <div class="box">
            <article class="media">
                <div class="media-content">
                    <div class="content">
                        <p>
                            <strong>{{note.tag}}</strong> <small>{{note.time}}</small>
                            <br>
                            {{note.text}}
                        </p>
                    </div>
                </div>
            </article>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            note: Object
        },
        components: {

        }
    }

</script>
